export type QueueJobStatus = 'pending' | 'processing' | 'completed' | 'failed' | 'cancelled';

export type QueueCountJob = {
  status: QueueJobStatus;
  attempts?: number;
  max_attempts?: number;
};

export type EmbeddingQueueCounts = {
  pending: number;
  processing: number;
  failed: number;
};

export function isRunnablePending(job: QueueCountJob): boolean {
  const attempts = job.attempts ?? 0;
  const maxAttempts = job.max_attempts ?? 3;
  return job.status === 'pending' && attempts < maxAttempts;
}

export function summarizeEmbeddingQueue(jobs: QueueCountJob[]): EmbeddingQueueCounts {
  let pending = 0;
  let processing = 0;
  let failed = 0;
  for (const job of jobs) {
    if (job.status === 'processing') processing += 1;
    else if (job.status === 'failed') failed += 1;
    else if (isRunnablePending(job)) pending += 1;
  }
  return { pending, processing, failed };
}

export function libraryEmbeddingCounts(
  documents: Array<{ hasContent: boolean; embedded: boolean }>
): { embedded: number; withContent: number; emptySkipped: number; notEmbedded: number } {
  let withContent = 0;
  let embedded = 0;
  let emptySkipped = 0;
  for (const doc of documents) {
    if (!doc.hasContent) {
      emptySkipped += 1;
      continue;
    }
    withContent += 1;
    if (doc.embedded) embedded += 1;
  }
  return {
    embedded,
    withContent,
    emptySkipped,
    notEmbedded: withContent - embedded,
  };
}
